import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import MachinesGroupsDt from '@/services/dataTransferModules/machinesGroupsDt'

export default function useMachinesGroups(params = {}) {
	const machinesGroupsDt = new MachinesGroupsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingMachinesGroup: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: machinesGroups,
		getEntities: getMachinesGroups,

		createEntity: createMachinesGroups,

		entity: machinesGroup,
		getEntity: getMachinesGroup,

		entityPopup: machinesGroupsPopup,
		getEntityPopup: getMachinesGroupsPopup,

		entityPreview: machinesGroupsPreview,
		getEntityPreview: getMachinesGroupsPreview,

		patchEntity: updateMachinesGroups,
		updateEntity: fullUpdateMachinesGroups,

		deleteEntity: deleteMachinesGroups,
	} = useBlProviders(
		machinesGroupsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Machinery groups loaded with an error'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error while adding machinery group',
				),

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error while editing machinery group',
				),

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		machinesGroups,
		machinesGroupsPreview,
		machinesGroupsPopup,
		machinesGroup,
		defaults,
		getMachinesGroups,
		getMachinesGroupsPreview,
		getMachinesGroupsPopup,
		getMachinesGroup,
		createMachinesGroups,
		deleteMachinesGroups,
		updateMachinesGroups,
		fullUpdateMachinesGroups,
	}
}
